import React from 'react';
import {Button, Icon, Table, Form, Header, Popup, Segment, Loader, Grid} from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import { fetchAcademicYears } from '../../Lookups/util';

import { IconHeader, FiltersOnStyle, HeaderCursor } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import {ExportReactCSV} from "../../util/ExportCSV";
import SearchTableData from "../../util/SearchTableData";
import PaginationFront from "../../util/PaginationFront";
import ReactExport from 'react-data-export';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const obj = {};
const fetchStudyPrograms = () => axios.post('study-programs/filter', { ...obj });

const NoDataMessage = () => <p>Nema studenata.</p>;
const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema studenata.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;


export default class GradStudents extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            filterData: [],
            academicYears: [],
            academicYearsClear: [],
            academicYear: '',
            studyPrograms: [],
            student: null,

            showFiltersOnButton: false,
            showFilterMode: false,
            loading: true,
            showStudentInfo: false,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: [],
            excelData: []

        };
        this.getStudents = this.getStudents.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
        this.filtersOff = this.filtersOff.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
    }

    componentDidMount() {
        axios.all([fetchAcademicYears(), fetchStudyPrograms()])
            .then(axios.spread((academicYearsRes, sProgramsRes) => {
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const studyPrograms = sProgramsRes.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.studyProgramBasicName ? el.studyProgramBasicName + ' - ' + el.name : el.name
                })).filter(el=> (!el.text.includes('TESTNI')));
                this.setState({
                    academicYears, studyPrograms, academicYearsClear: academicYearsRes.data
                });

                axios.get('/academic-years/current')
                    .then(res => {
                        this.setState({ academicYear: res.data.id }, () => { this.getStudents(); });
                    });
            }))
            .catch(err => {
                console.log('Failed to fetch academic years or study programs');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        }, () => this.getStudents());
    }


    getStudents() {
        this.setState({ loading: true });
        let obj = {};
        axios.post(`students/filter-grad-students/${this.state.academicYear}`, { ...obj })
            .then(res => {
                this.setState({ data: res.data.map(el=>({...el, department: el.departmentsSPOU.length  ? el.departmentsSPOU[0].organizationalUnitName : ''})), loading: false });
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.index},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyCycleName},
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });
    }

    getFilterData(firstName, lastName, studyProgramId) {
        this.setState({ loading: true });
        let docFilter = {};
        if (firstName) docFilter = {...docFilter, firstName};

        if (lastName) docFilter = {...docFilter, lastName};

        if (studyProgramId) docFilter = {...docFilter, studyProgramId};

        axios.post(`students/filter-grad-students/${this.state.academicYear}`, {...docFilter})

            .then(res => {
                const filterData = res.data;
                this.setState({filterData, showFiltersOnButton: true, showFilterMode: false, loading: false});
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.index},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyCycleName},
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                this.setState({error: true});
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }

    filtersOff() {
        const excelData = this.state.data.map(el => ([
            { value: el.lastName},
            { value: el.firstName},
            { value: el.index},
            { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
            { value: el.studyProgramBasicName},
            { value: el.studyProgramName},
            { value: el.studyCycleName},
        ]));
        this.setState({excelData: excelData});
        this.setState({
            showFilterMode: false, showFiltersOnButton: false,
        });
        return this.state.data;
    }

    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton  && this.state.results.length === 0) {
            return this.state.filterData;
        }
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {

        // const headersForExport = [
        //     { label: 'Prezime', key: 'lastName' },
        //     { label: 'Ime', key: 'firstName' },
        //     { label: 'Index', key: 'index' },
        //     { label: 'Odsjek', key: 'departmentsSPOU[0].organizationalUnitName' },
        //     { label: 'Studijski program', key: 'studyProgramBasicName' },
        //     { label: 'Plan i program', key: 'studyProgramName' },
        //     { label: 'Ciklus studija', key: 'studyCycleName' },
        // ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 200 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'Plan i program', width: { wpx: 300 } },
                    { title: 'Ciklus studija', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        if (this.state.showStudentInfo === true) {
            return <Redirect push to={{ pathname: '/spisak-studenata/informacije-o-studentu', state: { student: this.state.student } }} />;
        }
        return (
            <div>

                <Header style={IconHeader} floated="right" >

                    {this.state.showFiltersOnButton && <Button
                        onClick={this.filtersOff}
                        floated="left"
                        icon
                        labelPosition="right"
                        color="orange"
                        size="small"
                        style={FiltersOnStyle}
                    ><Icon className="remove" onClick={this.filtersOff} />
                        Filtriranje uključeno!
                    </Button>}
                    {this.getDataToRender().length ? <Popup
                            trigger={<Icon
                                link
                                circular
                                basic
                                floated="right"
                                name="filter"
                                onClick={() => { this.setState({ showFilterMode: !this.state.showFilterMode }); }}
                            />}
                            content="Filtriraj podatke"
                            hideOnScroll
                            position="top center"
                        />
                        : null}
                </Header>
                <br />
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.state.academicYears}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field />
                        <Form.Field />
                    </Form.Group>
                </Form>

                {this.state.showFilterMode && <Segment secondary clearing>
                    <Filters
                        onFilterData={this.getFilterData}
                        studyPrograms={this.state.studyPrograms}
                        filtersOff={this.filtersOff}
                        noIndex
                        sp
                    />
                </Segment>
                }
                {this.state.loading && <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /><br /></div>}
                {currentPosts.length ?
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={15} >
                                    <Grid columns={2} stackable>

                                        <Grid.Column width={14}>
                                            <SearchTableData profMozilla data={this.state.showFiltersOnButton ? this.state.filterData : this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgramName', 'studyProgramBasicName', 'department', 'studyCycleName']} />
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign={'center'}>
                                            <ExcelFile filename="Spisak apsolvenata" element={<Popup
                                                trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                    <Button.Content visible>
                                                        Excel
                                                    </Button.Content>
                                                </Button>}
                                                content="Preuzmi spisak u Excel-u"
                                                hideOnScroll
                                                position="top center"
                                            />}>
                                                <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studenti" />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan={15} >*/}
                                {/*        <span> {this.state.data && <ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} floated="right" fileName="Spisak apsolvenata" />}*/}
                                {/*            <SearchTableData data={this.state.showFiltersOnButton ? this.state.filterData : this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgramName', 'studyProgramBasicName', 'department', 'studyCycleName']} />*/}
                                {/*        </span>*/}
                                {/*</Table.HeaderCell>*/}
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Prezime i ime</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Index</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Odsjek</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Studijski program</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Ciklus studija</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {currentPosts.map((el, index) =>
                            (<Popup
                                trigger={<Table.Row
                                    key={index}
                                    style={HeaderCursor}
                                    onClick={() => {
                                        this.setState({ student: el, showStudentInfo: true });
                                        localStorage.setItem('student', JSON.stringify(el));
                                    }}
                                >
                                    <Table.Cell verticalAlign="middle" width={1}>
                                        {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {el.lastName} {el.firstName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.index}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {el.departmentsSPOU.map(e => <div>{e.organizationalUnitName} <br /></div>)}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {el.studyCycleName}
                                    </Table.Cell>
                                </Table.Row>}
                                content="Prikaz informacija o studentu"
                                hideOnScroll
                                position="left center"
                            />))}
                        </Table.Body>
                    </Table>
                    : (this.state.showFiltersOnButton && !this.state.loading) ?
                        <NoFilterDataMessage />
                        : !this.state.loading ? <NoDataMessage /> : ''
                }
                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/GradStudents.js